export const legacyQueryOptions = {
  staleTime: 60_000,
  retry: 1,
  refetchOnWindowFocus: false
} as const
